export default "__VITE_ASSET__7aaa7507__"